import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { moveUserFunds, walletType } from "../../dashboard/DashboardUtils";
import { moveFundsSuccess } from "../../../redux/WalletSlice";
import { toast } from "react-toastify";
import { handleAdminUpdateLease } from "../utils";
import { WalletContainer, WalletHeader } from "../../../auth/wallet/walletStyles";
import { Button, Typography, Box } from "@mui/material";
import { toggleFundLeaseRequest } from "../LeaseSlice";
import PinComponent from "../../../auth/wallet/PinComponent";
import SuccessModal from "../../../components/SuccessModal";

const FundLeaseRequest = ({ fundRequestTab, setFundRequestTab, leaseData }) => {
	const dispatch = useDispatch();
	const { adminWallet, moveFundsMessage } = useSelector((state) => state.wallet);

	const [loading, setLoading] = useState(false);
	const [updatedData, setUpdatedData] = useState(null);

	const mainWallet = adminWallet?.find((wallet) => wallet?.product === walletType.main);
	// console.log(mainWallet?.availableBalance, Number(leaseData?.amount));
	const onCloseModal = () => {
		dispatch(toggleFundLeaseRequest(false));
	};

	// FUNCTION TO MOVE FUNDS TO LEASE INVESTMENT
	const moveFundsBetweenWallets = async () => {
		const details = {
			amount: String(leaseData?.amount),
			source: "main",
			destination: walletType.leaseInvestment,
			message: "finance-admin-fund-lease-request",
		};

		if (mainWallet?.availableBalance < Number(leaseData?.amount)) {
			toast.error("Insuffient balance. Please fund your wallet!");
			return;
		}

		setLoading(true);
		try {
			const data = await moveUserFunds(details);
			dispatch(moveFundsSuccess(data));
			console.log(data);
		} catch (error) {
			toast.error(error);
		} finally {
			setLoading(false);
		}
	};

	// FUNCTION TO UPDATE ASSET IN PARSE
	const onUpdateLeaseInParse = async (id, data) => {
		setLoading(true);
		try {
			const res = await handleAdminUpdateLease(id, data);
			setUpdatedData(res);
			console.log(res);
		} catch (error) {
			toast.error(error);
		} finally {
			setLoading(false);
		}
	};

	const interestToEarn = (Number(leaseData?.amount?.replaceAll(",", "")) * leaseData?.interest) / 100;

	// ON PROCEED TO ACTIVE ASSETS
	const onFundRequestSuccess = () => {
		location.reload();
		setTimeout(() => {
			dispatch(toggleFundLeaseRequest(false));
		}, 500);
	};

	useEffect(() => {
		if (moveFundsMessage === "finance-admin-fund-lease-request") {
			const updatedData = {
				funded: true,
				investors: ["Fortcore Admin"],
				paidSlots: 4,
				investorsArray: [
					{
						user: "Fortcore Admin",
						slots: 4,
						amountToInvest: leaseData?.amount,
						interestToEarn,
						paid: false,
					},
				],
				type: "full-investment",
			};
			onUpdateLeaseInParse(leaseData?.objectId, updatedData);
		} else {
			return;
		}
	}, [moveFundsMessage]);

	useEffect(() => {
		if (updatedData) {
			setFundRequestTab(3);
		} else {
			return;
		}
	}, [updatedData]);

	return (
		<>
			{fundRequestTab === 1 && (
				<WalletContainer>
					<>
						<WalletHeader
							headerText='Fund Lease Request'
							context='First Line Finance Admin Funds Lease Request on Approval.'
							onCloseModal={onCloseModal}
						/>
						<Typography marginY={2} color='black'>{`NGN ${Number(
							leaseData?.amount
						).toLocaleString()} will be deducted from the admin wallet to fund this lease request.`}</Typography>
						<Box display='grid' gridTemplateColumns='1fr 1fr' gap={2}>
							<Button variant='outlined' color='error' onClick={onCloseModal}>
								cancel
							</Button>
							<Button variant='contained' color='primary' onClick={() => setFundRequestTab(2)}>
								proceed
							</Button>
						</Box>
					</>
				</WalletContainer>
			)}
			{fundRequestTab === 2 && (
				<PinComponent onClose={onCloseModal} onDeductFunds={moveFundsBetweenWallets} isLoading={loading} />
			)}
			{fundRequestTab === 3 && (
				<SuccessModal
					modalText={`The amount of N${Number(
						leaseData?.amount
					).toLocaleString()} has been deducted from the admin wallet to fund this request.`}
					btnText='proceed'
					onReqClick={onFundRequestSuccess}
				/>
			)}
		</>
	);
};

FundLeaseRequest.propTypes = {
	fundRequestTab: PropTypes.number,
	setFundRequestTab: PropTypes.func,
	leaseData: PropTypes.object,
};

export default FundLeaseRequest;
